import get from 'lodash.get';
import { fetchQuery } from 'react-relay';
import {
    hasUserSessionGeoInfoByIpAddress,
    setUserSessionGeoInfoByIpAddress,
} from '../../src/utils/regionalInfoHelpers';
import { userGeoInfoQuery } from '../queries/userGeoInfoQuery';

const getUserCountryCode = ({ relayEnv }) => {
    if (!hasUserSessionGeoInfoByIpAddress()) {
        fetchQuery(relayEnv, userGeoInfoQuery).then(data => {
            const userGeoInfo = get(data, 'viewer.regionalInfo[0]');
            setUserSessionGeoInfoByIpAddress(userGeoInfo);
        });
    }
};

export { getUserCountryCode };
